import { FieldBlock, TagsBlock } from '@coast/schemas';
import { ReactElement, useContext, useMemo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { CardRenderContext } from '@shared/components/blocks/contexts/render';
import { MBFieldBlock } from '@shared/components/blocks/lib/field';
import { TagList } from '@shared/components/blocks/lib/tags/tagList';
import { getTypoComponent } from '@shared/components/blocks/utils';
import { ColorThemeContext, grid } from '@shared/styles';

interface Props {
  block: TagsBlock;
  onPress?(): void;
  renderLeft?(): ReactElement;
}

export function MBTagsBlock({ block, onPress, renderLeft }: Props) {
  const renderContext = useContext(CardRenderContext);
  const colors = useContext(ColorThemeContext);
  const { values } = useCardFormContext();
  const fieldBlock = useMemo(
    // @ts-expect-error -- strict migration
    (): FieldBlock => ({ ...block, name: null, type: 'field', fieldType: 'text' }),
    [block],
  );

  const empty = useMemo(() => !block.names.some(name => !!values[name]?.length), [block, values]);

  const isCalendarOrAgenda = ['calendar', 'agenda'].includes(renderContext);
  const tagListWrapperStyle: StyleProp<ViewStyle> = [
    { paddingVertical: grid(0.5) },
    !isCalendarOrAgenda && { flexWrap: 'wrap' },
  ];

  return (
    <MBFieldBlock
      value={null}
      block={fieldBlock}
      onPress={onPress}
      renderLeft={renderLeft}
      presenter={(_value, _fieldType, _textStyle, _color) => {
        if (empty) {
          const TypoComponent = getTypoComponent(block.textStyle);
          return (
            <TypoComponent color={colors.foregroundInactive}>{block.placeholder}</TypoComponent>
          );
        }
        return (
          <MBView row wrap style={tagListWrapperStyle}>
            {block.names.map(fieldName => (
              <TagList key={fieldName} fieldName={fieldName} tagValues={values[fieldName]} />
            ))}
          </MBView>
        );
      }}
    />
  );
}
